import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogRef, MatDialog, MatCheckboxChange } from '@angular/material';
import * as _ from 'lodash';
import { FuseUtils } from '../../../../../../core/fuseUtils';
import { fuseAnimations } from '../../../../../../core/animations';
/** Local file */
import { orders, spekwo, displayValues, toastMsg, apiCalls, checkoutFields, role, parentMenuItemsConfig, menuItems, orderAgentRoles, decodeData } from '../../../utils/index';
/**Service file */
import { EcommerceOrdersService } from '../orders.service';
import { CommonOrdersService } from '../commonOrders.service';
import { AuthService } from '../../../authentication/auth.service';
/**Pipe file */
import { SkuKeyPipe } from '../../../pipesFiles/skuType.pipe';
import { ToastComponent } from '../../../common/toast.component';
import { FuseConfirmDialogComponent } from '../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ChangeDetectionStrategy } from "@angular/core";  // import
//Modal Pop up Component
import { Moment } from 'moment';
import { datepickerRange } from '../../../../../../constant';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { environment } from '../../../../../../../environments/environment';
import { OrdersEditNewComponent } from './orders-edit-new/orders-edit-new.component';
import { OrderViewLogsDialogComponent } from '../../../../../../core/components/order-view-logs/order-view-logs.component';
import { AuditHistoryService } from '../../../../../../core/services/audit-history.service';
import { OrderListAuditComponent } from './order-list-audit/order-list-audit.component';
import { OrderDetailsNewComponent } from './order-details-new/order-details-new.component';
import * as momentTz from 'moment-timezone';
export interface OrderStatus {    // common model file
  statusId: number;
  statusName: string;
  displayStatus: string;
}
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
  animations: fuseAnimations,
  providers: [SkuKeyPipe],
})

export class ListComponent {
  ownerDataSource: MatTableDataSource<OrdersData>;
  ordersValues = orders;
  role = role;
  spekwoValues = spekwo;
  displayValues = displayValues;
  roleid = orders.roleId;
  apiCalls = apiCalls;
  toastMsg = toastMsg;
  checkoutFields = checkoutFields;
  public userRole: any;
  public userRoleId: any;
  public userId: any;
  public roleId: any;
  public orderCount: any;
  endCursor: string;
  pageSize: number = 100;
  public allFinalOrders: any = [];
  allStatus: OrderStatus[];
  hasNextPage: boolean = false
  public validRole: boolean;
  notValidRole: boolean;
  visitedIndex = [0];
  displayedColumns = [
    'customer',
    'marketName',
    'address',
    'product',
    'date',
    'dueDate',
    'status',
    'assignPro',
    // 'proList',
    'solForm',
    'solForm1',
    // 'archive',
    'edit'
  ];
  defaultEstimatorName = 'Sky'; //Default estimator name if product new/processed
  @ViewChild(MatPaginator) ownerPaginator: MatPaginator;
  @ViewChild('filter') filter: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  isLoadingResults = false;

  selectedDate: { startDate: Moment, endDate: Moment };
  ranges: {} = datepickerRange.ranges;
  localeOptions: {} = datepickerRange.localeOptions;
  statusList = [];
  productList = [{ productId: 15, productName: "Full Spekwo" },
  { productId: 18, productName: "The Pre-List speK-Sheet" },
  { productId: 16, productName: "Specific Item speKwo" }];

  resultLength: number = 0;
  previousLoad: number = 100; // previous loaded count in items per page
  previousIndex: number = -1;
  isRateLimitReached = false;
  isBackClickedData = false;
  currIndex;
  searchForm: FormGroup;
  sortList: any = [{ sortId: "DUEDATE_ASC", sortName: "Next Due" },
  { sortId: "ORDERED_DATE_ASC", sortName: "Received Date" },
  { sortId: "ID_ASC", sortName: "Order Number" },
  { sortId: "STATUS_ID_ASC", sortName: "Status" }];
  isFilterFieldsEnable: boolean = false;
  isSortFieldEnable: boolean = false;
  roleStatusList = [];
  filterSolMenu = [];
  filterSolMenu1 = [];
  filterOrderMenu = [];

  menuItems = menuItems;
  isHighLevelPermission: any;
  dialogRef: any;
  timeout: any = null;
  isSortEnable: boolean = false;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private ordersService: EcommerceOrdersService,
    public commonOrdersService: CommonOrdersService,
    public authService: AuthService,
    public toastComponent: ToastComponent,
    private formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    public auditHistoryService: AuditHistoryService,
  ) {
    this.findRoles();
    this.userId = window.localStorage.getItem('userUID');
  }



  findRoles() {
    this.userRole = window.localStorage.getItem('role');
    this.roleId = window.localStorage.getItem('roleId');
    this.isHighLevelPermission = environment.ownerRoleId === this.roleId || environment.executiveRoleId === this.roleId
    this.authService.getRoleId(this.userRole).then((response: any) => {
      this.userRoleId = response ? response : '';
      this.validRole = this.userRoleId === this.roleid.owner || this.userRoleId === this.roleid.fo || this.userRoleId === this.roleid.qca || this.userRoleId === this.roleid.blueTeam || this.userRoleId === this.roleid.estimator ?
        true : false;
    }).catch(err => {
      console.log(err);
    });
  }

  async listUserStatusData(userId) {
    this.isLoadingResults = true;
    await this.commonOrdersService.statusRolePermissionByUserId(userId).then((responseData: any) => {
      let response = responseData.length > 0 ? responseData : [];

      for (let i = 0; i < response.length; i++) {
        let filterStatus = this.getStatusNameByStatusId(response[i].statusId);
        if (filterStatus.length > 0) {
          this.roleStatusList.push(response[i].statusId);
        }
      }
      this.isLoadingResults = false;
    }).catch((responseError) => {
      console.log("responseError", responseError);
      this.isLoadingResults = false;
    })
  }

  ngOnInit() {
    this.searchForm = this.createFactory();
    this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
      this.allStatus = statusRes.length > 0 ? statusRes : [];
      this.statusList = statusRes.length > 0 ? statusRes : [];
    });
    this.selectedDate = {
      startDate: moment(),
      endDate: moment(),
    };
  }

  async ngAfterViewInit() {
    this.commonOrdersService.allMenuItems.subscribe((menuItems) => {
      this.filterSolMenu = menuItems.menuItemsList.filter((menuItem) => {
        return menuItem.parentMenuItem === parentMenuItemsConfig.solEstimate;
      });

      this.filterSolMenu1 = menuItems.menuItemsList.filter((menuItem) => {
        return menuItem.parentMenuItem === parentMenuItemsConfig.solEstimate1;
      });

      this.filterOrderMenu = menuItems.menuItemsList.filter((menuItem) => {
        return menuItem.parentMenuItem === parentMenuItemsConfig.orderMenu;
      });
    });

    let roleId = window.localStorage.getItem('roleId');
    let userId = window.localStorage.getItem('userUID');
    this.isHighLevelPermission = environment.ownerRoleId === this.roleId || environment.executiveRoleId === this.roleId
    await this.listUserStatusData(userId);
    // if ((this.previousIndex == -1) && (this.resultLength == 0)) {
    //   this.checkAndCallOrdersList();
    // }
    // else {
    this.dataCheck();
    // }
  }

  createFactory() {
    return this.formBuilder.group({
      status: [''],
      product_type: [''],
      orderId: [''],
      orderDate: [''],
      dueDate: [''],
      sort: [''],
      unArchive: [true],
      searchStr: ['']
    });
  }

  // check and call func
  checkAndCallOrdersList() {
    this.commonOrdersService.prevLoadedOrder.subscribe((response) => {
      if ((this.previousIndex == -1) && (this.resultLength == 0)) {
        if (response && (response.totalCount > 0) && (response.allOrders) && (response.allOrders.length > 0)) {
          this.resultLength = response.totalCount;
          this.currIndex = response.pageIndex;
          this.setPreviousIndex(this.pageSize);
          this.isBackClickedData = true;
          this.allFinalOrders = response.allOrders;
          this.ownerPaginator.pageIndex = this.currIndex;
          this._changeDetectorRef.detectChanges();
          this.assignDataSource(response.allOrders);
        }
        else {
          this.dataCheck();
        }
      }
    }, () => {
    })
  }

  // data check
  dataCheck() {
    this.allFinalOrders = [];
    this.previousIndex = -1;
    this.isLoadingResults = true;
    this.listAllTheOrders();
  }


  listAllTheOrders(searchPayload?: any, sort?: any) {
    this.ownerPaginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.isRateLimitReached = false;

          this.setPreviousIndex(this.ownerPaginator.pageSize);

          var offset = this.ownerPaginator.pageIndex * this.ownerPaginator.pageSize;
          if (this.previousIndex < this.ownerPaginator.pageIndex) {
            if (searchPayload != undefined && sort == undefined && Object.keys(searchPayload).length > 0 && !this.isSortEnable) {
              let getFilterOrderHead1 = "query GetOrders($limit:Int,$offset:Int,";
              let getFilterOrderHead2 = "{allOrders(first:$limit,offset:$offset,orderBy: ORDERED_DATE_DESC, condition: {archive: null}, filter: {";
              if (searchPayload.productId) {
                getFilterOrderHead1 = getFilterOrderHead1 + "$productId: Int,";
                getFilterOrderHead2 = getFilterOrderHead2 + "productId: {equalTo: $productId},";
              }
              if (searchPayload.id) {
                getFilterOrderHead1 = getFilterOrderHead1 + "$id: Int,";
                getFilterOrderHead2 = getFilterOrderHead2 + "id: {equalTo: $id},";
              }
              if (searchPayload.orderedDate1 && searchPayload.orderedDate2) {
                getFilterOrderHead1 = getFilterOrderHead1 + "$orderedDate1: Date,";
                getFilterOrderHead2 = getFilterOrderHead2 + "orderedDate1: {equalTo: $orderedDate1},";
                getFilterOrderHead1 = getFilterOrderHead1 + "$orderedDate2: Date,";
                getFilterOrderHead2 = getFilterOrderHead2 + "orderedDate2: {equalTo: $orderedDate2},";
              }
              if (searchPayload.duedate1 && searchPayload.duedate2) {
                getFilterOrderHead1 = getFilterOrderHead1 + "$duedate1: Date,";
                getFilterOrderHead2 = getFilterOrderHead2 + "duedate1: {equalTo: $duedate1},";
                getFilterOrderHead1 = getFilterOrderHead1 + "$duedate2: Date,";
                getFilterOrderHead2 = getFilterOrderHead2 + "duedate2: {equalTo: $duedate2},";
              }
              if (searchPayload.statusId) {
                getFilterOrderHead1 = getFilterOrderHead1 + "$statusId: Int";
                getFilterOrderHead2 = getFilterOrderHead2 + "statusId: {equalTo: $statusId}";
              }
              getFilterOrderHead1 = getFilterOrderHead1 + ")";
              let statusFilter = !this.isHighLevelPermission && !searchPayload.statusId ? `, statusId: {in: [${this.roleStatusList}]}` : "";
              getFilterOrderHead2 = getFilterOrderHead2 + statusFilter + " })";
              searchPayload['limit'] = this.ownerPaginator.pageSize;
              searchPayload['offset'] = offset;
              return this.commonOrdersService!.getFilterOrders(getFilterOrderHead1 + getFilterOrderHead2 + this.spekwoValues.getFilterOrderBody, searchPayload);
            }
            else {
              let payload;
              let getFilterOrderHead1;
              let statusFilter;
              let getFilterOrderHead2;
              let getFilterOrderHead3;
              if (sort == "DUEDATE_ASC") {
                this.commonOrdersService.isNextDueSort.next(true);
              } else {
                this.commonOrdersService.isNextDueSort.next(false);
              }
              if (sort == "DUEDATE_ASC") {
                // const currentESTTime = this.getCurrentESTTime();
                const estTime = momentTz().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
                payload = {
                  "limit": this.ownerPaginator.pageSize,
                  "offset": offset,
                  "duedate": { "greaterThanOrEqualTo": estTime }
                };
                getFilterOrderHead1 = "query GetOrders($limit: Int, $offset: Int, $duedate: DatetimeFilter) {";
                statusFilter = !this.isHighLevelPermission ? `filter: {statusId: {in: [${this.roleStatusList}]} }` : "";
                getFilterOrderHead2 = `allOrders(first:$limit,offset:$offset,orderBy: ORDERED_DATE_DESC,condition:{archive:null}, ${statusFilter} )`;
                getFilterOrderHead3 = `allOrders(first: $limit, offset: $offset, orderBy: DUEDATE_ASC, condition: {archive: null}, filter: {duedate: $duedate})`;
              }
              else if (!this.isSortEnable) {
                payload = {
                  "limit": this.ownerPaginator.pageSize,
                  "offset": offset
                }
                getFilterOrderHead1 = "query GetOrders($limit:Int,$offset:Int) {";
                statusFilter = !this.isHighLevelPermission ? `filter: {statusId: {in: [${this.roleStatusList}]} }` : "";
                getFilterOrderHead2 = `allOrders(first:$limit,offset:$offset,orderBy: ORDERED_DATE_DESC,condition:{archive:null}, ${statusFilter} )`;
                getFilterOrderHead3 = "allOrders(first:$limit,offset:$offset,orderBy:";
              }
              if (sort != undefined) {
                if (sort != "DUEDATE_ASC") {
                  getFilterOrderHead1 = "query GetOrders($limit:Int,$offset:Int) {";
                  getFilterOrderHead3 = "allOrders(first:$limit,offset:$offset,orderBy:";
                  payload = {
                    "limit": this.ownerPaginator.pageSize,
                    "offset": offset
                  }
                  getFilterOrderHead3 = getFilterOrderHead3 + sort;
                  getFilterOrderHead3 = getFilterOrderHead3 + ",condition:{archive:null})";
                }
                // console.log("query", getFilterOrderHead1 + getFilterOrderHead3 + this.spekwoValues.getFilterOrderBody)
                return this.commonOrdersService!.getAllOrdersNew(getFilterOrderHead1 + getFilterOrderHead3 + this.spekwoValues.getFilterOrderBody, payload);
              }
              else if (!this.isSortEnable) {
                return this.commonOrdersService!.getAllOrdersNew(getFilterOrderHead1 + getFilterOrderHead2 + this.spekwoValues.getFilterOrderBody, payload);
              }
            }
          }

          else {
            return this.allFinalOrders;
          }
        }),
        map(
          (data) => {
            this.isLoadingResults = false;
            this.isRateLimitReached = false;

            if (this.previousIndex < this.ownerPaginator.pageIndex) {
              if (data && (data['nodes'] && data['nodes'].length > 0)) {
                this.previousIndex = this.ownerPaginator.pageIndex;
                this.setDataFormat(data['nodes']);
                this.resultLength = data['totalCount'];
              }
              else {
                this.isLoadingResults = false;
                this.isRateLimitReached = true;
                this.allFinalOrders = [];
                this.assignDataSource([]);
                this.resultLength = data['totalCount'];
              }
            }
            else {
              this.resultLength = this.resultLength;
              this.assignDataSource(this.allFinalOrders);
            }
            return this.allFinalOrders;
          }),
        catchError((error) => {
          console.log("order-list.component.ts:291 ~ catchError ~ error:", error)
          this.isLoadingResults = false;

          this.isRateLimitReached = true;
          return of([]);
        })
      ).subscribe(data => {
        // this.setTableDataSource(data);
      });
    () => {
      this.isLoadingResults = false;
    }
  }

  setDataFormat(response) {
    let tempOrderArray = _.uniqBy(response, 'id');
    this.commonOrdersService.checkDocProcess(tempOrderArray).then((response: any) => {
      this.allFinalOrders = this.allFinalOrders.concat(response);
      this.assignDataSource(this.allFinalOrders);
    });
  }

  setPreviousIndex(pageSize: number) {
    if (this.previousLoad != pageSize) {
      this.previousLoad = pageSize; // resetting page size
      if (this.allFinalOrders.length > pageSize) {
        this.previousIndex = Math.ceil((this.allFinalOrders.length / pageSize)) - 1; //setting previous index as per page size
      }
      else {
        this.previousIndex = Math.round((this.allFinalOrders.length / pageSize)) - 1; //setting previous index as per page size
      }

      if (this.previousIndex == -1) {
        this.allFinalOrders = []; //if paginator is first page - then set orders array empty
      }
    }

  }

  ngOnDestroy() { }

  assignDataSource(orders) {
    this.ownerDataSource = new MatTableDataSource(orders);
    setTimeout(() => this.ownerPaginator.length = this.resultLength);
    this.ownerDataSource.sort = this.sort;
    this.ownerDataSource.paginator = this.ownerPaginator;
    this.isLoadingResults = false;
    this.commonOrdersService.prevLoadedOrder.next({
      totalCount: this.resultLength,
      allOrders: this.allFinalOrders,
      pageIndex: this.ownerPaginator && this.ownerPaginator.pageIndex ? this.ownerPaginator.pageIndex : null
    });
  }

  onPaginateChange(event) {
    if (this.isBackClickedData && (this.previousIndex < this.ownerPaginator.pageIndex)) {
      this.isLoadingResults = true;
      this.listAllTheOrders();
    }
  }

  onNavigate(link) {
    link ? window.open(link, '_blank') :
      this.toastComponent.showToast(this.toastMsg.noReceipt);
  }

  /** Archive order */
  archiveOrder(order) {
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false,
    });
    let auditParams = {
      id: order && order.id ? order.id : null,
      archive: 'trash'
    }
    this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.deleteArchiveConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteArchiveHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteArchiveOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteArchiveCancel;
    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ordersService
          .archiveOrder(order.nodeId)
          .then((archiveRes: any) => {
            if (archiveRes == this.checkoutFields.archiveCompleteStatus) {
              _.remove(this.allFinalOrders, { id: order.id });
              this.assignDataSource(this.allFinalOrders);
              this.toastComponent.showToast(this.toastMsg.archiveSuccess);
              this.auditHistoryFunCall("Success", auditParams)
            }
          })
          .catch(err => {
            this.auditHistoryFunCall("Failed", auditParams)

            this.toastComponent.showToast(this.toastMsg.archiveFailed);
          });
      }
    });
  }

  /**
   * Filter table
   * @param filterValue
   */
  applyFilter(event) {
    // var filterData = FuseUtils.filterArrayByString(
    //   this.allFinalOrders,
    //   filterValue
    // );
    // this.ownerDataSource = new MatTableDataSource(filterData);
    // this.ownerDataSource.paginator = this.ownerPaginator;
    // this.ownerDataSource.sort = this.sort;
    if (this.searchForm.value.searchStr.trim().includes('/')) {
      this.searchForm.value.searchStr = moment(this.searchForm.value.searchStr).format('YYYY-MM-DD');
    }
    // setTimeout(() => {
    //   this.isLoadingResults = true;
    // }, 4000);
    // clearTimeout(this.timeout);
    // var $this = this;
    // this.timeout = setTimeout(function () {
    //   if (event.keyCode != 13) {
    //     if (event.target.value) {

    //       if ($this.isHighLevelPermission) {
    //         $this.isLoadingResults = true;
    //         $this.getRelatedOrderId(event.target.value.trim());
    //       } else {
    //         $this.isLoadingResults = true;
    //         $this.getRelatedOrderIdByRole(event.target.value.trim());
    //       }

    //     }
    //     // else {
    //     //   $this.onClear();
    //     // }
    //   }
    // }, 1000);
  }

  searchOrders(event) {
    if (this.searchForm.value.searchStr) {
      if (this.isHighLevelPermission) {
        this.isLoadingResults = true;
        this.getRelatedOrderId(this.searchForm.value.searchStr.trim());
      } else {
        this.isLoadingResults = true;
        this.getRelatedOrderIdByRole(this.searchForm.value.searchStr.trim());
      }
    } else {
      this.toastComponent.showToast("please enter anything you want in search field")
    }

  }

  getRelatedOrderId(searchString) {
    this.commonOrdersService.getAllOrderIdWithSearchStr(searchString, this.searchForm.value.unArchive).then((response: any) => {
      if (response.length > 0) {
        this.allFinalOrders = [];
        this.setDataFormat(response);
        this.resultLength = response.length;
      } else {
        this.allFinalOrders = [];
        this.isLoadingResults = false;
        this.assignDataSource([]);
        this.resultLength = response.length;
      }

    }).catch((error) => {
      console.log("Get Search based order having error", error);
    })
  }

  getRelatedOrderIdByRole(searchString) {
    let listOfOrderId = [];
    this.commonOrdersService.getAllOrderIdWithSearchStrByRoles(searchString, this.roleStatusList, this.searchForm.value.unArchive).then((response: any) => {
      console.log("response", response);
      if (response.length > 0) {
        this.allFinalOrders = [];
        this.setDataFormat(response);
        this.resultLength = response.length;
      } else {
        this.allFinalOrders = [];
        this.isLoadingResults = false;
        this.assignDataSource([]);
        this.resultLength = response.length;
      }

    }).catch((error) => {
      console.log("Get Search based order having error", error);
    })
  }


  getAllOrdersByIds(listOfOrderId) {
    this.commonOrdersService.getAllOrdersWithSearchStr(listOfOrderId).then((response: any) => {
      if (response.length > 0) {
        this.allFinalOrders = [];
        this.setDataFormat(response);
      } else {
        this.allFinalOrders = [];
        this.isLoadingResults = false;
      }
    }).catch((error) => {
      console.log("Get Search based orders having error", error);
    })
  }


  changeStatus(event, order) {
    let statusId = event.value;
    let orderId = order.id;
    let nodeId = order && order.inspectionReportsSrcByOrderId && order.inspectionReportsSrcByOrderId && order.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId ? order.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId.nodeId : null;

    if (nodeId) {
      this.ordersService.UpdateRequestStatusFromDropDown(nodeId, this.userRole, statusId).then((response: any) => {
      }).catch(err => {
        this.toastComponent.showToast(this.toastMsg.statusChange);
        console.log(err);
      });
    } else {
      this.ordersService.createStatus(orderId, statusId, this.userId).then((response: any) => {
      }).catch(err => {
        this.toastComponent.showToast(this.toastMsg.statusChange);
        console.log(err);
      });
    }
  }

  editOrder(order) {
    // const modal = this.dialog.open(OrderEditComponent,
    //   {
    //     data: order,
    //     width: 'calc(100% - 45%)',
    //     height: 'calc(100% - 45%)',
    //   });
    // modal.afterClosed().subscribe(result => {
    //   if (result) {
    //     order.buyerProperty = result.address;
    //     order.city = result.city;
    //     order.state = result.state;
    //     order.postcode = result.postcode;
    //     this.assignDataSource(this.allFinalOrders);
    //   }
    // });

    const modal = this.dialog.open(OrdersEditNewComponent,
      {
        data: order,
        width: 'calc(100% - 15%)',
        height: 'calc(100% - 10%)',
      });

    modal.afterClosed().subscribe(result => {
      if (result) {
        //  selected role
        let role = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.indrole ? result.data.updateOrder.order.indrole : null;
        let filterAgentRole = orderAgentRoles.filter((agentrole: any) => {
          return agentrole.value.toLowerCase() === role.toLowerCase();
        });

        order.buyerProperty = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.address ? result.data.updateOrder.order.address : "";
        order.city = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.city ? result.data.updateOrder.order.city : "";
        order.state = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.state ? result.data.updateOrder.order.state : "";
        order.postcode = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.postcode ? result.data.updateOrder.order.postcode : "";
        order.clientNameUI = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.firstName ? result.data.updateOrder.order.firstName : "";
        order.agentrole = filterAgentRole.length > 0 && filterAgentRole[0].key ? filterAgentRole[0].key : "";
        order.marketName = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.marketByMarketId && result.data.updateOrder.order.marketByMarketId.marketName ? decodeData(result.data.updateOrder.order.marketByMarketId.marketName) : "";
        order.firmName = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.firmByFirmId && result.data.updateOrder.order.firmByFirmId.firmsName ? decodeData(result.data.updateOrder.order.firmByFirmId.firmsName) : "";
        order.officeName = result && result.data && result.data.updateOrder && result.data.updateOrder.order
          && result.data.updateOrder.order.officeByOfficeId && result.data.updateOrder.order.officeByOfficeId.officesName ? decodeData(result.data.updateOrder.order.officeByOfficeId.officesName) : "";

        this.assignDataSource(this.allFinalOrders);
      }

    });

  }

  // getAddressValue(address, city, state, zip) {
  //   if ((zip && address && address.toString().includes(zip.toString())) ||
  //     (city && address && address.toString().includes(city.toString())) ||
  //     (state && address && address.toString().includes(state.toString()))) {
  //     return (address ? address.toString() : "");
  //   }
  //   else {
  //     return (order.address ? order.address.toString() : "") + (order.city ? (", " + order.city.toString()) : "") + (order.state ? (", " + order.state.toString()) : "") + (order.zip ? (", " + order.zip.toString()) : "");
  //   }
  // }

  getAddressValue(order) {
    if (order.latitude || order.longitude) {
      return (order.buyerProperty ? order.buyerProperty.toString() : "");
    }
    else {
      return (order.buyerProperty ? order.buyerProperty.toString() : "") + (order.city ? (", " + order.city.toString()) : "") + (order.state ? (", " + order.state.toString()) : "") + (order.zip ? (", " + order.zip.toString()) : "");
    }
  }

  proJobDetails(orderId) {
    this.router.navigate(['/apps/e-commerce/proJobDetails/' + orderId]);
  }

  orderDetails(orderId, index, solMenu) {
    this.ordersService.onOrderInfoSelected.next({
      loading: false,
      orderId: orderId,
      currentPageIndex: this.ownerPaginator.pageIndex,
      currentValue: this.allFinalOrders[index],
    });
    // this.router.navigate(['/apps/e-commerce/ordersdetails/' + orderId]);
    this.router.navigate([solMenu.url + orderId]);
  }

  reqWork(orderId, solMenu) {
    // this.router.navigate(['/apps/e-commerce/requestwork/' + orderId]);
    this.router.navigate([solMenu.url + orderId]);
  }

  assignProClick(orderId) {
    this.router.navigate(['/apps/e-commerce/orders/assign/' + orderId]);
  }
  /**Orders Detail view*/
  goToDetailPage(orderId) {
    this.router.navigate(['/apps/e-commerce/orders/' + orderId]);
  }

  /** To open report solution form */
  viewForm(orderId, solMenu) {
    // this.router.navigate(['/apps/e-commerce/solutionForm/' + orderId]);
    this.router.navigate([solMenu.url + orderId]);
  }

  onSearch() {
    this.previousIndex = -1;
    this.allFinalOrders = [];
    let searchPayload = {};
    if (this.searchForm.value['sort']) {
      this.isSortEnable = true;
      this.listAllTheOrders(searchPayload, this.searchForm.value['sort']);
    }
    else {
      if (this.searchForm.value['orderId']) {
        searchPayload['id'] = parseInt(this.searchForm.value['orderId']);
      }
      if (this.searchForm.value['product_type']) {
        searchPayload['productId'] = this.searchForm.value['product_type'];
      }
      if (this.searchForm.value['status']) {
        searchPayload['statusId'] = this.searchForm.value['status'];
      }
      if (this.searchForm.value['orderDate']) {
        searchPayload['orderedDate1'] = moment(this.searchForm.value['orderDate']).format("YYYY-MM-DD");
        searchPayload['orderedDate2'] = moment(this.searchForm.value['orderDate']).format("YYYY-MM-DD");
      }
      if (this.searchForm.value['dueDate']) {
        searchPayload['duedate1'] = moment(this.searchForm.value['dueDate']).format("YYYY-MM-DD");
        searchPayload['duedate2'] = moment(this.searchForm.value['dueDate']).format("YYYY-MM-DD");
      }
      this.listAllTheOrders(searchPayload);
    }
  }

  onClear() {
    this.searchForm = this.createFactory();
    this.isFilterFieldsEnable = false;
    this.searchForm.controls['orderId'].enable();
    this.isSortFieldEnable = false;
    this.previousIndex = -1;
    this.allFinalOrders = [];
    // this.searchForm.reset();
    this.isSortEnable = false;
    this.listAllTheOrders();
  }

  onSelectSort(data) {
    if (data.sortId) {
      this.isFilterFieldsEnable = true;
      this.searchForm.controls['orderId'].disable();
    }
    else {
      this.isFilterFieldsEnable = false;
      this.searchForm.controls['orderId'].enable();
    }
  }

  onSelectStatus(data) {
    if (data.statusId) {
      this.isSortFieldEnable = true;
    }
    else {
      this.isSortFieldEnable = false;
    }
  }

  onSelectProduct(data) {
    if (data.productId) {
      this.isSortFieldEnable = true;
    }
    else {
      this.isSortFieldEnable = false;
    }
  }

  onChangeNumber() {
    if (this.searchForm.value['orderId']) {
      this.isSortFieldEnable = true;
    }
    else {
      if (this.searchForm.value['dueDate'] || this.searchForm.value['orderDate'] || this.searchForm.value['status'] || this.searchForm.value['product_type']) {
        this.isSortFieldEnable = true;
      }
      else {
        this.isSortFieldEnable = false;
      }
    }
  }

  onChoseOrderDate(event) {
    if (event instanceof Date || event.value || this.searchForm.value['orderDate']) {
      this.isSortFieldEnable = true;
    }
    else {
      if (this.searchForm.value['orderId'] || this.searchForm.value['dueDate'] || this.searchForm.value['status'] || this.searchForm.value['product_type']) {
        this.isSortFieldEnable = true;
      }
      else {
        this.isSortFieldEnable = false;
      }
    }
  }

  onChoseDueDate(event) {
    if (event instanceof Date || event.value || this.searchForm.value['dueDate']) {
      this.isSortFieldEnable = true;
    }
    else {
      if (this.searchForm.value['orderId'] || this.searchForm.value['orderDate'] || this.searchForm.value['status'] || this.searchForm.value['product_type']) {
        this.isSortFieldEnable = true;
      }
      else {
        this.isSortFieldEnable = false;
      }
    }
  }

  getStatusNameByStatusId(statusId) {
    return this.allStatus.filter((status) => {
      return status.statusId === statusId;
    })
  }

  async claimOrders(selectedOrder) {
    this.isLoadingResults = true;

    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.ClaimConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.claim;
    this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.claimOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.claimCancel;
    this.confirmDialogRef.afterClosed().subscribe(async result => {
      if (result) {
        let listPayload = {
          orderId: selectedOrder && selectedOrder.id ? selectedOrder.id : null,
          statusId: selectedOrder && selectedOrder.statusId ? selectedOrder.statusId : null,
        };
        await this.commonOrdersService.getClaimOrderByStatus(listPayload).then((listRes: any) => {

          if (listRes.length == 0) {
            let payload = {
              statusId: selectedOrder && selectedOrder.statusId ? selectedOrder.statusId : null,
              orderId: selectedOrder && selectedOrder.id ? selectedOrder.id : null,
              userId: this.userId ? this.userId : null,
              roleId: this.roleId ? this.roleId : null,
            };

            this.commonOrdersService.createClaimOrder(payload).then((response: any) => {

              let claimResponse = response && response.data && response.data.createClaimOrder && response.data.createClaimOrder.claimOrder ? response.data.createClaimOrder.claimOrder : {};

              if (claimResponse) {
                this.toastComponent.showToast(this.toastMsg.claimOrderSuccess);
                this.createClaimAuditLog('Success', selectedOrder.id, payload, null);
                setTimeout(() => {
                  this.dataCheck();
                }, 5000);
              } else {
                this.toastComponent.showToast(this.toastMsg.claimOrderFailed);
                this.createClaimAuditLog('Failed', selectedOrder.id, payload, null);
                this.isLoadingResults = false;
              }

            }).catch((error) => {
              console.log("Claim order getting error", error);
              this.toastComponent.showToast(this.toastMsg.claimOrderFailed);
              this.createClaimAuditLog('Failed', selectedOrder.id, payload, null);
              this.isLoadingResults = false;
            })
          } else {
            let firstName = listRes[0].userByUserId && listRes[0].userByUserId.firstName ? listRes[0].userByUserId.firstName : "";
            let lastName = listRes[0].userByUserId && listRes[0].userByUserId.lastName ? listRes[0].userByUserId.lastName : "";
            this.toastComponent.showToast(this.toastMsg.alreadyclaimed + firstName + " " + lastName);
            this.isLoadingResults = false;
            setTimeout(() => {
              this.dataCheck();
            }, 5000);
          }
        }).catch((listErr) => {
          console.log("Claim order getting error", listErr);
          this.toastComponent.showToast(this.toastMsg.claimOrderFailed);
          this.isLoadingResults = false;
        });
      } else {
        setTimeout(() => {
          this.dataCheck();
        }, 5000);
      }
    });


  }

  refuseClaim(selectedOrder) {
    this.isLoadingResults = true;

    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.ClaimRefuseConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.claimRefuse;
    this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.refuse;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.claimCancel;
    this.confirmDialogRef.afterClosed().subscribe(async result => {
      if (result) {
        let claimData = selectedOrder && selectedOrder.orderClaimdData && selectedOrder.orderClaimdData.length > 0 ? selectedOrder.orderClaimdData : [];
        let filterCurrentClaim = claimData.filter((claim) => {
          return claim.statusId === claim.statusId
        });

        let claimId = filterCurrentClaim.length > 0 ? filterCurrentClaim[filterCurrentClaim.length - 1].claimOrderId : null;

        this.commonOrdersService.deleteClaimOrder(claimId).then((response: any) => {

          let claimResponse = response && response.data && response.data.updateClaimOrderByClaimOrderId && response.data.updateClaimOrderByClaimOrderId.claimOrder ? response.data.updateClaimOrderByClaimOrderId.claimOrder : {};

          if (claimResponse) {
            this.toastComponent.showToast(this.toastMsg.claimOrderRefused);
            this.isLoadingResults = false;
            setTimeout(() => {
              this.dataCheck();
            }, 5000);
          } else {
            this.toastComponent.showToast(this.toastMsg.claimOrderRefusedFailed);
            this.isLoadingResults = false;
          }

        }).catch((error) => {
          console.log("Claim order getting error", error);
          this.toastComponent.showToast(this.toastMsg.claimOrderRefusedFailed);
          this.isLoadingResults = false;
        })
      } else {
        setTimeout(() => {
          this.dataCheck();
        }, 5000);
      }
    })

  }

  solutionChanges(solMenu, order, index) {
    if (solMenu.menuItems === menuItems.solEstimate) {
      this.viewForm(order.id, solMenu)
    } else if (solMenu.menuItems === menuItems.orderDetails) {
      this.orderDetails(order.id, index, solMenu)
    } else if (solMenu.menuItems === menuItems.requestWork) {
      this.reqWork(order.id, solMenu)
    }
    else if (solMenu.menuItems === menuItems.viewFinal) {
      this.viewFinal(order.id, solMenu)
    }
  }

  viewFinal(orderId: any, solMenu: any) {
    this.router.navigate([solMenu.url + orderId]);
  }

  viewOrderLog(orderRes) {
    this.dialogRef = this.dialog.open(OrderViewLogsDialogComponent, {
      width: '100%',
      panelClass: 'log-info-dialog',
      data: {
        orderId: Number(orderRes.id)
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        console.log("response", response)
      })
  }


  orderMenu(menu, order) {
    if (menu.menuItems === "edit_order") {
      this.editOrder(order);
    } else if (menu.menuItems === "view_receipt") {
      this.onNavigate(order.stripeLink)
    } else if (menu.menuItems === "order_audit_log") {
      this.viewOrderLog(order)
    }
  }


  createClaimAuditLog(status, orderId, newData, oldData) {

    let auditLogPayload = {
      roleId: this.roleId,
      userId: this.userId,
      orderId: orderId,
      newData: newData,
      oldData: oldData,
      auditType: "create_order_claim",
      logsDesc: "Order claimed",
      platform: "Executive Dashboard",
      status: status
    };

    this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);

  }

  auditHistoryFunCall(status, newData) {

    let auditLogPayload = {
      roleId: window.localStorage.getItem('roleId'),
      userId: window.localStorage.getItem('userUID'),
      orderId: newData && newData.id ? newData.id : null,
      newData: newData,
      oldData: null,
      auditType: 'archive',
      logsDesc: "archived",
      platform: "Executive Dashboard",
      status: status,
      createdAt: "now()"
    };
    this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
  }


  viewLog() {
    this.dialogRef = this.dialog.open(OrderListAuditComponent, {
      width: 'calc(100% - 40%)',
      height: 'calc(100% - 25%)',
      panelClass: 'log-info-dialog',

    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
      })
  }

  /** Below Working but 12Am above is throw error  
  getCurrentESTTime() {
    const options: any = {
      timeZone: 'America/New_York', // Set the time zone to Eastern Standard Time
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false, // Use 24-hour format
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const estDateTime = formatter.format(new Date());

    return estDateTime;
  }*/
}

export interface OrdersData {
  name: string;
  address: string;
  lineItems: string;
  orderDate: string;
  dueDate: string;
  status: string;
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-list.component.ts